const postJson = async (path, body) => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/auth${path}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Something went wrong. Please try again.");
  }

  return data;
};

export const sendPasswordResetOtp = (email) =>
  postJson("/forgot-password/send-otp", { email });

export const resetPasswordWithOtp = ({ email, otp, newPassword }) =>
  postJson("/forgot-password/verify-otp", { email, otp, newPassword });
